/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SanpayIntermediaryInformationViewModel
 */
export interface SanpayIntermediaryInformationViewModel {
    /**
     * 
     * @type {string}
     * @memberof SanpayIntermediaryInformationViewModel
     */
    institutionAgentCode: string;
    /**
     * 
     * @type {string}
     * @memberof SanpayIntermediaryInformationViewModel
     */
    sanpayCode: string;
    /**
     * 
     * @type {string}
     * @memberof SanpayIntermediaryInformationViewModel
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof SanpayIntermediaryInformationViewModel
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof SanpayIntermediaryInformationViewModel
     */
    emailAddress: string;
}

/**
 * Check if a given object implements the SanpayIntermediaryInformationViewModel interface.
 */
export function instanceOfSanpayIntermediaryInformationViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "institutionAgentCode" in value;
    isInstance = isInstance && "sanpayCode" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "surname" in value;
    isInstance = isInstance && "emailAddress" in value;

    return isInstance;
}

export function SanpayIntermediaryInformationViewModelFromJSON(json: any): SanpayIntermediaryInformationViewModel {
    return SanpayIntermediaryInformationViewModelFromJSONTyped(json, false);
}

export function SanpayIntermediaryInformationViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SanpayIntermediaryInformationViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'institutionAgentCode': json['InstitutionAgentCode'],
        'sanpayCode': json['SanpayCode'],
        'firstName': json['FirstName'],
        'surname': json['Surname'],
        'emailAddress': json['EmailAddress'],
    };
}

export function SanpayIntermediaryInformationViewModelToJSON(value?: SanpayIntermediaryInformationViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InstitutionAgentCode': value.institutionAgentCode,
        'SanpayCode': value.sanpayCode,
        'FirstName': value.firstName,
        'Surname': value.surname,
        'EmailAddress': value.emailAddress,
    };
}

